import { ChakraProvider } from "@chakra-ui/react";
import { AlertProvider } from "./context/alertContext";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import Home from "./components/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Newsletter from "./components/Newsletter";
import PreFooter from "./components/PreFooter";
import AboutUs from "./components/AboutUs";
import Promotion1 from "./components/Promotion1";
import Community from "./components/Community";
import Influencer from "./components/Influencer";
import Help from "./components/Help";
import AgentDashboard from "./components/AgentDashboard";
import AgentLogin from "./components/AgentLogin";
import PrivacyPolicy from "./components/PrivacyPolicy"; 
import TermsOfService from "./components/TermsOfService";
import CanadaTerms from "./components/CanadaTerms";
import { useState } from "react";
import Resources from "./components/Resources";
import Blog from "./components/Blog";
import CreditBuildingHabits2026 from "./components/CreditBuildingHabits2026";
import BestOnlineLoanOptionsCanada2026 from "./components/BestOnlineLoanOptionsCanada2026";
import FactorsThatAffectLoanApproval from "./components/FactorsThatAffectLoanApproval";
import HowToSpotAndAvoidLoanScams from "./components/HowToSpotAndAvoidLoanScams";
import HowToBorrowSmartly from "./components/HowToBorrowSmartly";
import UnderstandingAPRInterestTotalLoanCost from "./components/UnderstandingAPRInterestTotalLoanCost";
import CreditAndLoanGuide from "./components/CreditAndLoanGuide";
import AvoidHiddenFees from "./components/AvoidHiddenFees";
import SafeOnlineBorrowing from "./components/SafeOnlineBorrowing";
import EligibilityPage from "./components/EligibilityPage";
import OntarioEligibilityPage from "./components/OntarioEligibilityPage";
import AlbertaEligibilityPage from "./components/AlbertaEligibilityPage";
import BritishColumbiaEligibilityPage from "./components/BritishColumbiaEligibilityPage";
import ManitobaEligibilityPage from "./components/ManitobaEligibilityPage";
import SaskatchewanEligibilityPage from "./components/SaskatchewanEligibilityPage";
import NewfoundlandAndLabradorEligibilityPage from "./components/NewfoundlandAndLabradorEligibilityPage";
import NewBrunswickEligibilityPage from "./components/NewBrunswickEligibilityPage";
import NovaScotiaEligibilityPage from "./components/NovaScotiaEligibilityPage";
import ShortTermLoan from "./components/ShortTermLoan";
import PaydayLoan from "./components/PaydayLoan";
import ReferralTermsConditions from "./components/ReferralTermsConditions";
import ApplyPreliminaryPage from "./components/ApplyPreliminaryPage";
import ApplyPersonalInfoPage from "./components/ApplyPersonalInfoPage";
import ApplyIncomeInfoPage from "./components/ApplyIncomeInfoPage";
import ApplyBankDetailsPage from "./components/ApplyBankDetailsPage";
import ApplyInstantBankVerificationPage from "./components/ApplyInstantBankVerificationPage";
import ApplyFinalConfirmationPage from "./components/ApplyFinalConfirmationPage";
import ApplyReapplyPage from "./components/ApplyReapplyPage";
import CustomerSignInPage from "./components/CustomerSignInPage";
import UserSignInPage from "./components/UserSignInPage";
import UserProfilePage from "./components/UserProfilePage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";

function App() {
  const location = useLocation();
  const [agentAuthed, setAgentAuthed] = useState(false);
  const handleLogout = () => setAgentAuthed(false);
  const hideNewsletterOnPaths = ["/apply", "/apply/reapply", "/apply/sign-in", "/apply/personal-info", "/apply/income-info", "/apply/bank-details", "/apply/instant-bank-verification", "/apply/confirmation", "/sign-in", "/profile", "/reset-password"];
  const shouldShowNewsletter = !hideNewsletterOnPaths.includes(location.pathname);

  return (
    <ChakraProvider>
      <AlertProvider>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/promotions" element={<Promotion1 />} />
          <Route path="/community" element={<Community />} />
          <Route path="/influencer" element={<Influencer />} />
          <Route path="/help" element={<Help />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/agent" element={agentAuthed ? <AgentDashboard onLogout={handleLogout} /> : <AgentLogin onLogin={() => setAgentAuthed(true)} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/canada-terms" element={<CanadaTerms />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/top-7-credit-building-habits-2026" element={<CreditBuildingHabits2026 />} />
          <Route path="/blog/best-online-loan-options-canada-2026" element={<BestOnlineLoanOptionsCanada2026 />} />
          <Route path="/blog/factors-that-affect-loan-approval" element={<FactorsThatAffectLoanApproval />} />
          <Route path="/blog/how-to-spot-and-avoid-loan-scams" element={<HowToSpotAndAvoidLoanScams />} />
          <Route path="/blog/how-to-borrow-smartly-through-the-year" element={<HowToBorrowSmartly />} />
          <Route path="/blog/understanding-apr-interest-and-total-loan-cost" element={<UnderstandingAPRInterestTotalLoanCost />} />
          <Route path="/blog/credit-and-loan-guide-for-newcomers-canada-2026" element={<CreditAndLoanGuide />} />
          <Route path="/blog/how-to-avoid-hidden-fees-in-loans" element={<AvoidHiddenFees />} />
          <Route path="/blog/safe-online-borrowing-security-checklist" element={<SafeOnlineBorrowing />} />
          <Route path="/eligibility" element={<EligibilityPage />} />
          <Route path="/ontario-eligibility" element={<OntarioEligibilityPage />} />
          <Route path="/alberta-eligibility" element={<AlbertaEligibilityPage />} />
          <Route path="/british-columbia-eligibility" element={<BritishColumbiaEligibilityPage />} />
          <Route path="/manitoba-eligibility" element={<ManitobaEligibilityPage />} />
          <Route path="/saskatchewan-eligibility" element={<SaskatchewanEligibilityPage />} />
          <Route path="/newfoundland-and-labrador-eligibility" element={<NewfoundlandAndLabradorEligibilityPage />} />
          <Route path="/new-brunswick-eligibility" element={<NewBrunswickEligibilityPage />} />
          <Route path="/nova-scotia-eligibility" element={<NovaScotiaEligibilityPage />} />
          <Route path="/short-term-loan" element={<ShortTermLoan />} />
          <Route path="/payday-loan" element={<PaydayLoan />} />
          <Route path="/referral-terms" element={<ReferralTermsConditions />} />
          <Route path="/apply" element={<ApplyPreliminaryPage />} />
          <Route path="/apply/reapply" element={<ApplyReapplyPage />} />
          <Route path="/apply/sign-in" element={<CustomerSignInPage />} />
          <Route path="/apply/personal-info" element={<ApplyPersonalInfoPage />} />
          <Route path="/apply/income-info" element={<ApplyIncomeInfoPage />} />
          <Route path="/apply/bank-details" element={<ApplyBankDetailsPage />} />
          <Route path="/apply/instant-bank-verification" element={<ApplyInstantBankVerificationPage />} />
          <Route path="/apply/confirmation" element={<ApplyFinalConfirmationPage />} />
          <Route path="/sign-in" element={<UserSignInPage />} />
          <Route path="/reset-password" element={<ForgotPasswordPage />} />
          <Route path="/profile" element={<UserProfilePage />} />
        </Routes>
        {shouldShowNewsletter && <Newsletter />}
        <PreFooter/>
        <Footer />
      </AlertProvider>
    </ChakraProvider>
  );
}

export default App;
